export default __webpack_public_path__ + "static/team-image-5-450f1f878c79db23e37ceb19ffa7c29f.png";